import {
    Typography,
    Box,
    Grid,
    Paper,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
} from "@mui/material";
import TopBar from "../../components/topBar/TopBar";
import { useEffect, useState } from "react";
import SendRequest from "../../request/SendRequest";
import Loading from "../../components/Loading/loading";
import Icon from "../../components/Icon/Icon";
import Card from "../../components/Card/Card";
import { useParams, useNavigate } from "react-router-dom";
import { styled, useTheme } from '@mui/material/styles';

const PaymentTransactionDetail = () => {
    const params = useParams();
    const theme = useTheme();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState()

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        let query = null
        try {
            // decode query
            const raw = window.atob(decodeURIComponent(params.query))
            const array = Uint8Array.from(raw, c => c.charCodeAt(0))
            const unzip = window.fflate.inflateSync(array)
            const ascii = new TextDecoder().decode(unzip)
            query = JSON.parse(decodeURIComponent(ascii))
        } catch (error) {
            setLoading(false)
            console.error('Unable to decode query.', error)
        }

        if (query) {
            const fetchData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + `subscriber/paymentTransactionDetails?transactionStartDate=${query.startDate}&transactionEndDate=${query.endDate}&entryNameLabel=${query.title}` }).then(response => {
                if (response.status === 200) {
                    setData(response.data.data);
                }
            })

            Promise.all([fetchData]).then(() => {
                setLoading(false)
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                setLoading(false)
            })
        }
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        '&.MuiTableCell-root': {
            verticalAlign: 'top',
        },
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#FFF3F6',
            color: '#555555',
            fontWeight: 500,
            fontSize: 14,
            border: '1px solid #FFFFFF',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            color: '#555555',
            border: '1px solid #FFFFFF',
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: '#F0F0F0',
        },
    }));

    return (
        <>
            <Box textAlign="center">
                <Loading show={loading} />
                <TopBar />
                <Box display={"flex"} flexDirection={"column"} gap={"8px"} padding={{ xs: "24px 8px", sm: "24px 16px", md: "24px 24px" }}>
                    {!loading &&
                        <>
                            <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} gap={"16px"} >
                                {
                                    data?.entryNameLabel &&
                                    <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }} padding={"8px 10px 8px 10px"}>
                                        <Typography fontSize={18} fontWeight={700} color={"rgba(67, 71, 78, 1)"} textAlign={"left"}>{data.entryNameLabel}</Typography>
                                    </Box>
                                }
                                <Box width={"100%"} display={"flex"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }}>
                                    <Button
                                        variant="outlined"
                                        style={{ color: "#43474E", borderColor: "#43474E", minWidth: "82px", marginRight: "auto", display: "flex", justifyContent: "left", alignItems: "center", flexDirection: 'row', gap: '5px', padding: "2px 4px 2px 4px" }}
                                        onClick={() => navigate("/billing-history?tab=transaction")}
                                    >
                                        <Icon name="back" />
                                        返回
                                    </Button>
                                </Box>
                            </Box>
                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} >
                                <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }}>
                                    <Card fullWidth>
                                        {
                                            (data?.payableAmount != undefined) &&
                                            <Box width={"100%"} display={"flex"} flexDirection={"row"} gap={"5px"} alignItems={"center"} padding={"12px 0 24px 0"}>
                                                <Typography fontWeight={700} color={"#43474E"}>今期應繳費用</Typography>
                                                <Typography fontSize={"14px"} fontWeight={500} color={"#FF395D"}>{`$${data.payableAmount}`}</Typography>
                                            </Box>
                                        }
                                        {
                                            data?.transactions && data?.transactions?.length > 0 &&
                                            <TableContainer>
                                                <Table sx={{
                                                    minWidth: 300,
                                                    width: "max-content",
                                                    [theme.breakpoints.up('sm')]: {
                                                        width: "100%",
                                                    }
                                                }}
                                                size="small" aria-label="payment Record table">
                                                    <TableHead>
                                                        <StyledTableRow>
                                                            <StyledTableCell>合約編號​</StyledTableCell>
                                                            <StyledTableCell>項目內容​</StyledTableCell>
                                                            <StyledTableCell>收費金額​</StyledTableCell>
                                                            <StyledTableCell>入帳金額</StyledTableCell>
                                                            <StyledTableCell>結欠​</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.transactions.map((paymentItem, index) => (
                                                            <StyledTableRow
                                                                key={index}
                                                            >
                                                                <StyledTableCell>
                                                                    {paymentItem.contractNo}
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    <Box display={"flex"} flexDirection={"column"} gap={"2px"} >
                                                                        {paymentItem.itemName && <Typography component="span" style={{fontSize: "14px"}}>{paymentItem.itemName}</Typography>}
                                                                        {paymentItem.itemPaymentMethod && <Typography component="span" style={{fontSize: "12px"}}>{paymentItem.itemPaymentMethod}</Typography>}
                                                                        {paymentItem.itemDate && <Typography component="span" style={{fontSize: "12px"}}>{paymentItem.itemDate}</Typography>}
                                                                    </Box>
                                                                </StyledTableCell>
                                                                {
                                                                    paymentItem.itemType === "charge" ?
                                                                        <>
                                                                            <StyledTableCell>{paymentItem.amount ? `$${paymentItem.amount}` : ''}</StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell>{paymentItem.amount ? `$${paymentItem.amount}` : ''}</StyledTableCell>
                                                                        </>
                                                                }
                                                                <StyledTableCell>{`$${paymentItem.balance}`}</StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        }
                                        {
                                            (!data?.transactions || data?.transactions?.length === 0) &&
                                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} padding={"24px 0"}>
                                                <Typography fontSize={16} fontWeight={500} color={"#43474E"}>沒有交易紀錄</Typography>
                                            </Box>
                                        }
                                    </Card>
                                </Box>
                            </Box>
                        </>
                    }
                </Box>
            </Box>
        </>
    )
}

export default PaymentTransactionDetail